<template>
  <div class="div-breadcrumb">
    <div class="breadcrumb">
      <ul>
        <li
          v-for="(breadcrumb, idx) in breadcrumbs"
          :key="idx"
          :class="{ linked: !!breadcrumb.link }"
          @click="routeTo(idx)"
        >
          {{ breadcrumb.name }}
        </li>
      </ul>
    </div>
  </div>
</template>
<style src="./breadcrumbs.scss" lang="scss">
</style>
<script>
export default {
  name: 'Breadcrumb',
  components: {},
  props: {
    breadcrumbs: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {};
  },
  methods: {
    routeTo(pRouteTo) {
      if (this.breadcrumbs[pRouteTo].link) this.$router.push(this.breadcrumbs[pRouteTo].link);
    }
  }
};
</script>
